import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merge Tailwind classes with clsx */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Format a number as BRL currency */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
}

/** Format a 14-digit CNPJ string */
export function formatCnpj(cnpj: string): string {
  const clean = cnpj.replace(/\D/g, "");
  if (clean.length !== 14) return cnpj;
  return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}-${clean.slice(12)}`;
}

/** Get risk level color class */
export function getRiskColor(level: string): string {
  switch (level) {
    case "BAIXO":
      return "text-risk-low";
    case "MEDIO":
      return "text-risk-medium";
    case "ALTO":
      return "text-risk-high";
    case "CRITICO":
      return "text-risk-critical";
    default:
      return "text-slate-500";
  }
}

/** Get risk level background class */
export function getRiskBg(level: string): string {
  switch (level) {
    case "BAIXO":
      return "bg-green-50 text-green-700 border-green-200";
    case "MEDIO":
      return "bg-amber-50 text-amber-700 border-amber-200";
    case "ALTO":
      return "bg-red-50 text-red-700 border-red-200";
    case "CRITICO":
      return "bg-red-100 text-red-800 border-red-300";
    default:
      return "bg-slate-50 text-slate-600 border-slate-200";
  }
}
